export const canOpenPaymentPlanPreview = (scheduleId: unknown): boolean => {
  if (typeof scheduleId === "number") {
    return Number.isFinite(scheduleId) && scheduleId > 0;
  }

  return typeof scheduleId === "string" && scheduleId.trim().length > 0;
};
